import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Home } from 'app/home/home';
import { General } from './model//general.model';


@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss']
})
export class GeneralComponent extends Home implements OnInit {

  constructor(private router: Router, public general: General) {
    super(router);
  }

  ngOnInit() {
  }

  doGeneral(general: General, valid: boolean) {
    if (!valid)
      return;

    this.doUpdated(general);
  }

  doUpdated(general) {

  }

  addAddress() {

  }

}
